module.exports = __webpack_public_path__ + "img/3-5.2da67783.svg";